
/**
 * 추가 메타데이터
 */
export type HandleWebhookRequestMetadata = { [key: string]: unknown };
